export default {"src":"/_next/static/media/netherlands.c5cc56e6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};